<template>
    <div id="search-bar" class="base-inline">
        <label class="label">{{ this.$t("LabelFilterResults") }}</label> 
        <input 
            :value="search" 
            style="text-transform:uppercase" 
            type="text" 
            @input="onInputHandler"
            :placeholder="this.$t('LabelFilterHint')" />
    </div>
</template>

<script>
import { SET_SEARCH } from '../store/actions.type'
import { mapState } from 'vuex';
export default {
    computed: {
        ...mapState(["contestList", "search"])
    },
    methods: {
        onInputHandler(e) {
            this.$store.dispatch(SET_SEARCH, e.target.value);
        }
    }
}
</script>